<template>
<div class="chapter">
<div class="inner_page">
<p class="SP-1"> </p>
<p class="DED"><span class="ePub-I">For my mom, Debbie Palombo,</span> <span class="ePub-I">who crossed an ocean with me so I could tell this story,</span> <span class="ePub-I">and who always, always believed</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ded02a4a